import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0B1120] text-slate-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-md bg-[#F97316] flex items-center justify-center text-white font-black">P</div>
              <span className="font-display font-extrabold text-lg text-white">PropertyByKilo</span>
            </div>
            <p className="text-sm text-slate-400">India's premium PropTech platform for brokers and buyers.</p>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/search" className="hover:text-white">Buy Property</Link></li>
              <li><Link to="/search?project_status=new_launch" className="hover:text-white">New Projects</Link></li>
              <li><Link to="/cities" className="hover:text-white">All Cities</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3">For Brokers</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/become-broker" className="hover:text-white">Join as Broker</Link></li>
              <li><Link to="/login" className="hover:text-white">Broker Login</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>About Us</li>
              <li>Contact</li>
              <li>Privacy Policy</li>
              <li>Terms & Conditions</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-6 text-center text-sm text-slate-500">
          © 2026 PropertyByKilo. All rights reserved. Made with pride in India.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
